<script>
    import {CONTACT} from "../js/constants.js";
    import {rawPhone} from "../js/utils.js";
    import department$ from "../stores/department$";
    import Icon from "./icons/Icon.svelte";

    const dt = new Date();
    const year = dt.getFullYear();

</script>

<footer>
    <div class="footer">
        <div class="container">
            <div class="text-center">
                <ul class="quick-links mb-5">
                    <li>&bull; <a href="/{$department$.link_code}">Book a Transfer</a></li>
                    <li>&bull; <a href="/{$department$.link_code}/terms" target="_blank">Terms</a></li>
                </ul>

                <h2 class="title mb-4">CONTACT US</h2>
                <ul class="contact mb-3">
                    <li>
                        <div class="icon">
                            <Icon name="phone" size="18"/>
                        </div>
                        <a href="tel:{rawPhone(CONTACT.PHONE)}">{CONTACT.PHONE}</a>
                    </li>
                    <li>
                        <div class="icon">
                            <Icon name="envelope" size="18"/>
                        </div>
                        <a href="mailto:{CONTACT.EMAIL}">{CONTACT.EMAIL}</a>
                    </li>
                </ul>
                <div class="social-links">
                    <a href="https://wa.me/{rawPhone(CONTACT.WHATSAPP)}" class="social-icon" target="_blank"
                       rel="noopener noreferrer">
                        <span><Icon name="whatsapp" size="30"/></span>
                    </a>
                    <a href="viber://chat?number={encodeURIComponent(rawPhone(CONTACT.VIBER))}" class="social-icon">
                        <span><Icon name="viber" size="30"/></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bar">
        <div class="container text-center">
            © {year} Regent Mile. All rights reserved.
        </div>
    </div>
</footer>

<style>
    footer .footer {
        color: #bdebff;
        background: #162e44;
        padding: 70px 0;
    }

    footer .footer .title {
        color: #fff;
        font-size: 20px;
    }

    footer .footer-bar {
        color: #596875;
        background: #11263a;
        padding: 30px 0;
    }

    footer ul.quick-links {
        list-style: none;
        display: flex;
        align-items: center;
        gap: 30px;
        width: max-content;
        padding: 0;
        margin: auto;

    }

    footer ul.quick-links li a {
        color: #fff;
        padding: 4px 0 4px 0;
    }

    footer ul.quick-links li a:hover {
        color: #01b3a7;
    }


    footer ul.contact {
        list-style: none;
        display: flex;
        align-items: center;
        gap: 30px;
        width: max-content;
        padding: 0;
        margin: auto;
    }

    footer ul.contact li {
        display: flex;
        align-items: center;
        gap: 5px;
        margin-bottom: 15px;
        color: #fff;
    }

    footer ul.contact li .icon {
        display: block;
        color: #01b3a7;
    }

    footer ul.contact li a {
        color: #fff;
    }

    footer ul.contact li a:hover {
        color: #01b3a7;
    }


    footer .social-links {
        display: flex;
        gap: 15px;
        width: max-content;
        margin: auto;
    }

    footer .social-links .social-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 35px;
        height: 35px;
        color: #fff;
        background: #01b3a7;
        border-radius: 3px;
        padding: 5px;
    }

    footer .social-links .social-icon:hover {
        background: #50ba87;
    }

    @media (max-width: 576px) {
        footer ul.contact {
            flex-direction: column;
            gap: 0;
        }
    }
</style>